<template>
  <div class="detailLine">
    <div v-for="(item, i) in props.list" :key="i" class="item">
      <p class="name">{{ item.name }}</p>
      <p
        v-if="item.value"
        class="value"
        :style="{ color: item.color || 'rgba(60, 60, 60, 1)' }"
      >
        {{ item.value }}
      </p>
      <img v-if="item.img" :src="item.img" @error="setDefaultImage" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import img_failed from '@/assets/images/score/img_failed.png'
const setDefaultImage = (event) => {
  event.target.src = img_failed
}
const props = defineProps({
  list: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => [
      {
        name: '实付积分',
        value: '',
        valueColor: 'rgba(60, 60, 60, 1)'
      },
      {
        name: '订单编号',
        value: '',
        valueColor: 'rgba(60, 60, 60, 1)'
      },
      {
        name: '兑换时间',
        value: '',
        valueColor: 'rgba(60, 60, 60, 1)'
      }
    ]
  }
})
</script>

<style scoped lang="less">
.detailLine {
  padding: 5px 16px 5px 16px;
  background: #fff;
  margin-top: 8px;
  .item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 11px 0;
    box-sizing: content-box;
    .name {
      color: rgba(110, 110, 110, 1);
      font-size: 14px;
    }
    .value {
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
    }
    > img {
      width: 25px;
      height: 25px;
    }
  }
}
</style>
